module.exports = __webpack_public_path__ + "img/brush.841f7dbc.svg";